export const STEP_UP_MFA_COMPLETED_EVENT = 'inflomatrix:step-up-mfa-completed';

export function emitStepUpMfaCompleted(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(STEP_UP_MFA_COMPLETED_EVENT));
}
